var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "my-location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "my-location"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 36 0 36 36 0 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,3 C10.545,3 4.5,9.045 4.5,16.5 C4.5,22.755 8.76,28.005 14.535,29.535 L18,33 L21.465,29.535 C27.24,28.005 31.5,22.755 31.5,16.5 C31.5,9.045 25.455,3 18,3 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: 1,
    d: "M18,3 C10.545,3 4.5,9.045 4.5,16.5 C4.5,22.755 8.76,28.005 14.535,29.535 L18,33 L21.465,29.535 C27.24,28.005 31.5,22.755 31.5,16.5 C31.5,9.045 25.455,3 18,3 Z M18,6 C20.49,6 22.5,8.01 22.5,10.5 C22.5,12.99 20.49,15 18,15 C15.51,15 13.5,12.99 13.5,10.5 C13.5,8.01 15.51,6 18,6 Z M18,27.45 C14.25,27.45 10.935,25.53 9,22.62 C9.045,19.635 15,18 18,18 C20.985,18 26.955,19.635 27,22.62 C25.065,25.53 21.75,27.45 18,27.45 Z",
    id: "Shape",
    fill: "#E7AC5B",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default __webpack_public_path__ + "static/media/my-location.b3d92c986c1aea709ad060f855b649cf.svg";
export { ForwardRef as ReactComponent };